import { $Q } from "../utils/query-selector";
import { updateCartLocalWithRemoteItems } from "./cart";
import { syncCartRemote } from "./cart-services-async";
import axios from "axios";

/*
VAR GLOBAL WINDOW OBJECT add in snippet sidecart

CART_REMOTE
CUSTOMER_ID
*/

/**
Validates remote and local cart items and performs necessary actions.
@async
@function validateRemoteLocal
@returns {Promise<void>}
*/
export const validateRemoteLocal = async () => {

  if (!CUSTOMER_ID) return;

  const cartRemoteString = CART_REMOTE ? CART_REMOTE.stringify : "";
  const { data: { items: cartCurrent } } = await axios.get(`${shopUrl}/cart.js`);

  const stringCompareLocal = cartCurrent.map(
    (cart) => `${cart.variant_id}|${cart.quantity}`).join(',');

  if (!compareStrings(cartRemoteString, stringCompareLocal)) {
    $Q(".overlay-async").classList.remove("hidden");
    // await addNewItemsCart();
    // await updateCartRemote(CART_CURRENT);
    $Q(".overlay-async").classList.add("hidden");
    // $Q(".async-message").classList.remove("hidden");
    // setTimeout(() => {
    //   $Q(".async-message").classList.add("hidden");
    // }, 2000)
  }
}

/**
Checks if remote cart items exist and returns the items array.
@function remoteExist
@returns {Array} - Array of remote cart items, or an empty array if not found.
*/
const remoteExist = () => {
  const cartRemote = CART_REMOTE;
  if (cartRemote) {
    return cartRemote.items;
  }

  return [];
}

/**
Updates the remote cart with the current cart items.
note dev:
Send your local cart after updating, adding or removing
items from the cart to this function, to update the metafield.
@async
@function updateCartRemote
@param {Array} cartCurrent - Array of current cart items.
@returns {Promise<void>}
*/
const updateCartRemote = async (cartCurrent) => {

  if (!CUSTOMER_ID) return;

  const userEmail = CUSTOMER_EMAIL;
  const userId = CUSTOMER_ID;

  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString("en-US", { weekday: "short", day: "2-digit", month: "short", year: "numeric" });

  const cartRemoteItems = remoteExist();

  const itemsCurrent = cartCurrent.map((item) => (

    {
      productTitle: item.product_title,
      variantTitle: `${item.variant_title}`,
      variantId: item.variant_id,
      quantity: item.quantity,
    }
    ))

  const itemsIUnique = getUniqueVariantItems(itemsCurrent.concat(cartRemoteItems));

  const cartItemNew = {
    email: userEmail,
    updateAt: formattedDate,
    items: itemsIUnique,
  }

  await syncCartRemote(cartItemNew, userId);
}

/**
Retrieves an array of unique variant items from the given array of items.
@function getUniqueVariantItems
@param {Array} itemsDuplicate - Array of items with possible duplicates.
@returns {Array} - Array of unique variant items.
*/
const getUniqueVariantItems = (itemsDuplicate) => {
  const arrayItemsUnique = [];
  const uniqueVariantIds = new Set(itemsDuplicate.map((item) => item.variantId));
  uniqueVariantIds.forEach((id) => {
    const item = itemsDuplicate.find((item) => item.variantId === id);
    arrayItemsUnique.push(item);
  });

  return arrayItemsUnique;
}

/**
Adds new items from the remote cart to the local cart.
@async
@function addNewItemsCart
@returns {Promise<void>}
*/
const addNewItemsCart = async () => {
  const cartRemoteItems = remoteExist();

  if (!cartRemoteItems.length) return;

  const dataUpdate = {}

  for (const item of cartRemoteItems) {
    if (!(item.variantId in dataUpdate)) {
      dataUpdate[item.variantId] = item.quantity
    } else {
      dataUpdate[item.variantId] = dataUpdate[item.variantId] + item.quantity
    }
  }

  await updateCartLocalWithRemoteItems(dataUpdate);
}

/**

Compares two strings by creating maps of character counts for each string.
@function compareStrings
@param {string} str1 - First string to compare.
@param {string} str2 - Second string to compare.
@returns {boolean} - True if the strings have the same character counts, false otherwise.
*/
function compareStrings(str1, str2) {
  const map1 = createMap(str1);
  const map2 = createMap(str2);

  if (map1.size !== map2.size) {
    return false;
  }

  for (const [key, value] of map1) {
    if (!map2.has(key) || map2.get(key) !== value) {
      return false;
    }
  }

  return true;
}

function createMap(str) {
  const map = new Map();
  const pairs = str.split(',');

  for (const pair of pairs) {
    const [key, value] = pair.split('|');
    map.set(key, parseInt(value));
  }

  return map;
}
